import { createContext, useContext, ReactNode } from 'react';
import { useJacKeyNudges } from '@/hooks/useJacKeyNudges';
import { JacKeyNudge } from '@/components/jackey/JacKeyNudge';

interface JacKeyNudgeContextType {
  showBadgeNudge: (badgeKey: string) => void;
}

const JacKeyNudgeContext = createContext<JacKeyNudgeContextType | null>(null);

export function JacKeyNudgeProvider({ children }: { children: ReactNode }) {
  const { activeNudge, showBadgeNudge, dismissNudge } = useJacKeyNudges();

  return (
    <JacKeyNudgeContext.Provider value={{ showBadgeNudge }}>
      {children}
      
      {/* Global nudge display - positioned at bottom of screen */}
      {activeNudge && (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50">
          <JacKeyNudge
            key={activeNudge.id}
            type={activeNudge.type}
            onDismiss={dismissNudge}
          />
        </div>
      )}
    </JacKeyNudgeContext.Provider>
  );
}

export function useJacKeyNudgeContext() {
  const context = useContext(JacKeyNudgeContext);
  if (!context) {
    throw new Error('useJacKeyNudgeContext must be used within a JacKeyNudgeProvider');
  }
  return context;
}
